import Modal from "@mui/material/Modal";
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { ThreeDots } from 'react-loader-spinner';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';

import { getRequest } from '../../config';
import AnimatedPage from '../../components/AnimatedPage';
import { toggleModal } from '../../reducers/modalReducer';
import ModalWrapper from "../../components/common/Modal/ModalWrapper";
import SuperFlowHeader from "../../components//header/SuperFlowHeader.js";


const InvestorMatchStats = () => {

    const dispatch = useDispatch();
    const navigation = useNavigate();
    let [searchParams] = useSearchParams();

    let user = useSelector((state) => state.user);
    let modal = useSelector((state) => state.modal);
    let { selectedCompany } = useSelector(state => state.company);
    let company = { ...selectedCompany };

    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);
    const [promptScore, setPromptScore] = useState(0);

    useEffect(() => {
        let companyId = searchParams.get('companyId');
        if (companyId) getInvestorMatchStats(companyId);
    }, []);


    const getInvestorMatchStats = async (id) => {
        try {
            setLoading(true);
            const res = await getRequest(`/company/getInvestorMatchStats/${id}`);
            if (res && res?.['code'] == 200) setStats(res?.['body']);
        } catch (error) {
            console.error('Error fetching stats:', error?.['response']?.['data']);
        } finally {
            setLoading(false);
        }
    };

    const getInvestorMatchStatusData = () => {
        if (!stats?.investorMatchStatus) return [];
        const { thisMonth, lastMonth, ytd, lastYear } = stats.investorMatchStatus;
        return [
            { index: 'No. of Applications', thisMonth: thisMonth.total, lastMonth: lastMonth.total, ytd: ytd.total, lastYear: lastYear.total },
            { index: 'Accepted', thisMonth: thisMonth.accepted, lastMonth: lastMonth.accepted, ytd: ytd.accepted, lastYear: lastYear.accepted, color: 'green' },
            { index: 'Rejected', thisMonth: thisMonth.rejected, lastMonth: lastMonth.rejected, ytd: ytd.rejected, lastYear: lastYear.rejected, color: 'red' },
            { index: 'Still Pending', thisMonth: thisMonth.pending, lastMonth: lastMonth.pending, ytd: ytd.pending, lastYear: lastYear.pending, color: 'orange' },
            { index: 'Added to Portfolio (post investment)', thisMonth: thisMonth.addedToPortfolio, lastMonth: lastMonth.addedToPortfolio, ytd: ytd.addedToPortfolio, lastYear: lastYear.addedToPortfolio },
        ];
    };

    const getSourceData = () => {
        if (!stats?.source) return [];
        const { thisMonth, lastMonth, ytd, lastYear } = stats.source;
        return [
            { index: 'Integration added', thisMonth: thisMonth.integration, lastMonth: lastMonth.integration, ytd: ytd.integration, lastYear: lastYear.integration },
            { index: 'Manually added', thisMonth: thisMonth.manual, lastMonth: lastMonth.manual, ytd: ytd.manual, lastYear: lastYear.manual },
            { index: 'Diligentsia InvestorMatch', thisMonth: thisMonth.diligentsia, lastMonth: lastMonth.diligentsia, ytd: ytd.diligentsia, lastYear: lastYear.diligentsia },
        ];
    };

    const getPromptResponseData = () => {
        if (!stats?.promptResponseScore) return [];
        const { thisMonth, lastMonth, ytd, lastYear } = stats.promptResponseScore;
        return [
            { index: 'Prompt Response Score', thisMonth, lastMonth, ytd, lastYear },
        ];
    };

    const investorMatchStatusData = getInvestorMatchStatusData();
    const sourceData = getSourceData();
    const promptResponseData = getPromptResponseData();
    const rejectionReasons = stats?.rejectionReasons || [];

    if (loading) {
        return (
            <div className='w100 df fdc px8rem poppins-font-style'>
                <div className='df jcc aic py3rem'>
                    <ThreeDots height="80" width="80" color="#8496f4" ariaLabel="three-dots-loading" />
                </div>
            </div>
        );
    }

    return (
        <div className='w100 df fdc px8rem poppins-font-style'>
            <SuperFlowHeader page='InvestorMatch Stats' company={company} breadcrum={['Investor View', '/Portfolio Index', '/InvestorMatch', '/Module Report']} heading={<>Investor<span className='c4'>Match</span></>} />

            {/* Statistics Title */}
            <div className="w100 df jcc mb2rem"><h2 className="c15 fs1-5rem fw500">Statistics</h2></div>

            {/* InvestorMatch Status Table */}
            <div className="mb3rem">
                <h3 className="c14 fs1-25rem fw600 ml2rem mb1rem ttu ls1px">INVESTORMATCH STATUS</h3>
                <div className="bo31 bw1px bss br25px bg5 p2rem">
                    <table className="w100" style={{ borderCollapse: 'collapse' }}>
                        <thead>
                            <tr className="bg5">
                                <th className="c15 fs14px fw600 ttu pb1rem bg5 tal" style={{ borderBottom: '1px solid #d3d3d3' }}>INDEX</th>
                                <th className="c15 fs14px fw600 ttu pb1rem bg5 tac" style={{ borderBottom: '1px solid #d3d3d3' }}>THIS MONTH</th>
                                <th className="c15 fs14px fw600 ttu pb1rem bg5 tac" style={{ borderBottom: '1px solid #d3d3d3' }}>LAST MONTH</th>
                                <th className="c15 fs14px fw600 ttu pb1rem bg5 tac" style={{ borderBottom: '1px solid #d3d3d3' }}>YTD</th>
                                <th className="c15 fs14px fw600 ttu pb1rem bg5 tac" style={{ borderBottom: '1px solid #d3d3d3' }}>LAST YEAR</th>
                            </tr>
                        </thead>
                        <tbody>
                            {investorMatchStatusData.map((row, idx) => (
                                <tr key={idx} className={idx !== investorMatchStatusData.length - 1 ? 'bb31 bw1px' : ''}>
                                    <td className={`c15 fs14px py1rem tal ${row.color || ''}`}>{row.index}</td>
                                    <td className="c15 fs14px py1rem tac">{row.thisMonth}</td>
                                    <td className="c15 fs14px py1rem tac">{row.lastMonth}</td>
                                    <td className="c15 fs14px py1rem tac">{row.ytd}</td>
                                    <td className="c15 fs14px py1rem tac">{row.lastYear}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Source Table */}
            <div className="mb4rem">
                <h3 className="c14 fs1-25rem fw600 ml2rem mb1rem ttu ls1px">SOURCE</h3>
                <div className="bo31 bw1px bss br25px bg5 p2rem">
                    <table className="w100" style={{ borderCollapse: 'collapse' }}>
                        <thead>
                            <tr className="bg5">
                                <th className="c15 fs14px fw600 ttu pb1rem bg5 tal" style={{ borderBottom: '1px solid #d3d3d3' }}>INDEX</th>
                                <th className="c15 fs14px fw600 ttu pb1rem bg5 tac" style={{ borderBottom: '1px solid #d3d3d3' }}>THIS MONTH</th>
                                <th className="c15 fs14px fw600 ttu pb1rem bg5 tac" style={{ borderBottom: '1px solid #d3d3d3' }}>LAST MONTH</th>
                                <th className="c15 fs14px fw600 ttu pb1rem bg5 tac" style={{ borderBottom: '1px solid #d3d3d3' }}>YTD</th>
                                <th className="c15 fs14px fw600 ttu pb1rem bg5 tac" style={{ borderBottom: '1px solid #d3d3d3' }}>LAST YEAR</th>
                            </tr>
                        </thead>
                        <tbody>
                            {sourceData.map((row, idx) => (
                                <tr key={idx} className={idx !== sourceData.length - 1 ? 'bb31 bw1px' : ''}>
                                    <td className="c15 fs14px py1rem tal">{row.index}</td>
                                    <td className="c15 fs14px py1rem tac">{row.thisMonth}</td>
                                    <td className="c15 fs14px py1rem tac">{row.lastMonth}</td>
                                    <td className="c15 fs14px py1rem tac">{row.ytd}</td>
                                    <td className="c15 fs14px py1rem tac">{row.lastYear}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Prompt Response Score Table */}
            <div className="mb3rem pr">
                <div className="df aic">
                    <h3 className="c14 fs1-25rem fw600 ml2rem my1rem ttu ls1px">PROMPT RESPONSE SCORE</h3>
                    <div className='tooltip-input'>
                        <span className="tooltip-area cp pr" style={{ top: '-10px', left: '10px' }}>
                            <i className="icon">
                                <svg classNaw2rem me="h2rem" width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_2661_6508)">
                                        <path d="M9 18.1133C13.9628 18.1133 18 14.076 18 9.11328C18 4.15052 13.9628 0.113281 9 0.113281C4.03724 0.113281 0 4.15052 0 9.11328C0 14.076 4.03724 18.1133 9 18.1133ZM9 1.91328C12.97 1.91328 16.2 5.14326 16.2 9.11328C16.2 13.0833 12.97 16.3133 9 16.3133C5.02998 16.3133 1.8 13.0833 1.8 9.11328C1.8 5.14326 5.02998 1.91328 9 1.91328Z" fill="#FC7785" />
                                        <path d="M8.69665 11.6919C8.50359 11.6919 8.34746 11.5299 8.34746 11.3297C8.34746 10.8559 8.41225 10.4466 8.54117 10.1025C8.63575 9.84312 8.78929 9.5817 9.00049 9.31758C9.15597 9.12538 9.43454 8.84446 9.8375 8.47618C10.2405 8.10723 10.5022 7.81355 10.6233 7.59446C10.7445 7.37538 10.8041 7.13613 10.8041 6.87672C10.8041 6.40696 10.6272 5.995 10.2741 5.63949C9.92107 5.28398 9.48767 5.10656 8.97458 5.10656C8.47898 5.10656 8.06501 5.26785 7.73331 5.58976C7.49102 5.82497 7.30897 6.15696 7.18847 6.58573C7.10555 6.88008 6.82892 7.06825 6.53545 7.03196C6.16359 6.98627 5.9187 6.60454 6.02495 6.23156C6.18821 5.65831 6.4616 5.19661 6.84447 4.84581C7.37635 4.35723 8.07991 4.11328 8.95514 4.11328C9.88156 4.11328 10.6207 4.37471 11.1727 4.89823C11.7247 5.42175 12 6.05414 12 6.79608C12 7.22551 11.9028 7.62135 11.7091 7.9829C11.5154 8.34514 11.1358 8.78532 10.5715 9.30414C10.1925 9.65293 9.9444 9.91032 9.82778 10.0756C9.71117 10.241 9.62501 10.4312 9.5693 10.6455C9.52783 10.8048 9.49933 11.0387 9.48378 11.3458C9.47406 11.5394 9.31923 11.6912 9.13265 11.6912H8.69665V11.6919ZM8.28268 13.4258C8.28268 13.0461 8.57939 12.7383 8.94542 12.7383C9.31145 12.7383 9.60817 13.0461 9.60817 13.4258C9.60817 13.8055 9.31145 14.1133 8.94542 14.1133C8.57939 14.1133 8.28268 13.8055 8.28268 13.4258Z" fill="#FC7785" stroke="#FC7785" stroke-width="0.5" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_2661_6508">
                                            <rect width="18" height="18" fill="white" transform="translate(0 0.113281)" />
                                        </clipPath>
                                    </defs>
                                </svg>
                                <div className="overlay-box" style={{ left: 'auto', top: '0', right: '22px', zIndex: '9', width: '400px' }}>
                                    <p className="fs14px">The Prompt Response Score is a score provided to each applicant company to indicate the promptness of any initial response from an investor – whether positive or negative. Any initial response that takes more than 10 days is marked negatively</p>
                                </div>
                            </i>
                        </span>
                    </div>
                </div>
                <div className="bo31 bw1px bss br25px bg5 p2rem">
                    <table className="w100" style={{ borderCollapse: 'collapse' }}>
                        <thead>
                            <tr className="bg5">
                                <th className="c15 fs14px fw600 ttu pb1rem bg5 tal" style={{ borderBottom: '1px solid #d3d3d3' }}>INDEX</th>
                                <th className="c15 fs14px fw600 ttu pb1rem bg5 tac" style={{ borderBottom: '1px solid #d3d3d3' }}>THIS MONTH</th>
                                <th className="c15 fs14px fw600 ttu pb1rem bg5 tac" style={{ borderBottom: '1px solid #d3d3d3' }}>LAST MONTH</th>
                                <th className="c15 fs14px fw600 ttu pb1rem bg5 tac" style={{ borderBottom: '1px solid #d3d3d3' }}>YTD</th>
                                <th className="c15 fs14px fw600 ttu pb1rem bg5 tac" style={{ borderBottom: '1px solid #d3d3d3' }}>LAST YEAR</th>
                            </tr>
                        </thead>
                        <tbody>
                            {promptResponseData.map((row, idx) => (
                                <tr key={idx}>
                                    <td className="c15 fs14px py1rem tal">{row.index}</td>
                                    <td className="c15 fs14px py1rem tac">{row.thisMonth}</td>
                                    <td className="c15 fs14px py1rem tac">{row.lastMonth}</td>
                                    <td className="c15 fs14px py1rem tac">{row.ytd}</td>
                                    <td className="c15 fs14px py1rem tac">{row.lastYear}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div className="pa" style={{ top: '-20px', right: '0px' }}>
                        <div className="progress-bar" style={{ width: 60, height: 60, backgroundColor: '#FBFBFB', borderRadius: '50%' }}>
                            <CircularProgressbar
                                className={`${promptScore > 83 ? 'green' : promptScore > 66.6 ? 'orange' : 'red'}`}
                                value={promptScore || 0}
                                text={`${promptScore || 0}%`}
                                strokeWidth={18}
                                styles={buildStyles({
                                    strokeLinecap: 'round',
                                    strokeWidth: '5px',
                                    textSize: '18px',
                                    pathTransitionDuration: 0.5,
                                    trailColor: '#d6d6d6',
                                    backgroundColor: '#fc7785',
                                    dominantBaseline: 'ideographic',
                                })}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* Reason For Rejection Table */}
            <div className="mb3rem">
                <h3 className="c14 fs1-25rem fw600 ml2rem mb1rem ttu ls1px">REASON FOR REJECTION</h3>
                <div className="bo31 bw1px bss br25px bg5 p2rem">
                    <table className="w100" style={{ borderCollapse: 'collapse' }}>
                        <thead>
                            <tr className="bb31 bw1px">
                                <th className="c15 fs14px fw600 ttu pb1rem bg5 tal" style={{ borderBottom: '1px solid #d3d3d3' }}>REASONS</th>
                                <th className="c15 fs14px fw600 ttu pb1rem bg5 tac" style={{ borderBottom: '1px solid #d3d3d3' }}>THIS MONTH</th>
                                <th className="c15 fs14px fw600 ttu pb1rem bg5 tac" style={{ borderBottom: '1px solid #d3d3d3' }}>LAST MONTH</th>
                                <th className="c15 fs14px fw600 ttu pb1rem bg5 tac" style={{ borderBottom: '1px solid #d3d3d3' }}>YTD</th>
                                <th className="c15 fs14px fw600 ttu pb1rem bg5 tac" style={{ borderBottom: '1px solid #d3d3d3' }}>LAST YEAR</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rejectionReasons.map((row, idx) => (
                                <tr key={idx} className={idx !== rejectionReasons.length - 1 ? 'bb31 bw1px' : ''}>
                                    <td className="c15 fs14px py1rem tal" style={{ fontStyle: 'italic', minWidth: '500px' }}>{row.reason}</td>
                                    <td className="c15 fs14px py1rem tac">{row.thisMonth}</td>
                                    <td className="c15 fs14px py1rem tac">{row.lastMonth}</td>
                                    <td className="c15 fs14px py1rem tac">{row.ytd}</td>
                                    <td className="c15 fs14px py1rem tac">{row.lastYear}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );

}

export default InvestorMatchStats;